<script lang="ts">
  import { loadVideoSource } from "$lib/hooks/preload-video";

  let { video }: {
    video: HTMLVideoElement | undefined;
  } = $props();

  $effect(() => {
    if (!video) return;
    const player = video;
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
    let visible = false;
    let soundEnabled = true;
    let audioBlocked = false;
    let active = true;

    function playVideo() {
      if (!visible || document.hidden || reducedMotion.matches) return;
      loadVideoSource(player);
      player.muted = !soundEnabled;
      void player.play().then(() => {
        if (active) audioBlocked = false;
      }).catch(() => {
        if (!active || !visible || document.hidden) return;
        player.muted = true;
        audioBlocked = soundEnabled;
        void player.play().catch(() => undefined);
      });
    }

    function syncPlayback() {
      if (!visible || document.hidden || reducedMotion.matches) {
        player.muted = true;
        player.pause();
      } else playVideo();
    }
    const retryAudio = () => {
      if (soundEnabled && audioBlocked) playVideo();
    };

    const observer = new IntersectionObserver(([entry]) => {
      visible = entry.isIntersecting && entry.intersectionRatio >= 0.35;
      syncPlayback();
    }, { threshold: [0, 0.35] });
    observer.observe(player);
    document.addEventListener("pointerup", retryAudio);
    document.addEventListener("keydown", retryAudio);
    document.addEventListener("visibilitychange", syncPlayback);
    reducedMotion.addEventListener("change", syncPlayback);

    return () => {
      active = false;
      observer.disconnect();
      document.removeEventListener("pointerup", retryAudio);
      document.removeEventListener("keydown", retryAudio);
      document.removeEventListener("visibilitychange", syncPlayback);
      reducedMotion.removeEventListener("change", syncPlayback);
      player.muted = true;
      player.pause();
    };
  });
</script>
